import {
  ActionType,
  createReducer,
  createStandardAction,
  StateType
} from "typesafe-actions";

type DeviceExportActionType = "START_EXPORT" | "STOP_EXPORT";

export const startExport = createStandardAction<DeviceExportActionType>(
  "START_EXPORT"
)<{
  tenantId: string;
}>();

export const stopExport = createStandardAction<DeviceExportActionType>(
  "STOP_EXPORT"
)<{
  tenantId: string;
}>();

const DeviceExportActions = { startExport, stopExport };
export type DeviceExportAction = ActionType<typeof DeviceExportActions>;

type ExportState = {
  exporting: boolean;
  downloadLink: string;
};

type InventoryState = {
  [tenantId: string]: ExportState;
};

const defaultExportState: InventoryState = {};

export const DeviceExportReducer = createReducer(defaultExportState)
  .handleAction(startExport, (state, { payload }) => ({
    ...state,
    [payload.tenantId]: {
      ...state[payload.tenantId],
      exporting: true
    }
  }))
  .handleAction(stopExport, (state, { payload }) => ({
    ...state,
    [payload.tenantId]: {
      ...state[payload.tenantId],
      exporting: false
    }
  }));

export type DeviceExportState = StateType<typeof DeviceExportReducer>;
